<template>
  <div class="auth-header">
    <div class="auth-header__title" data-cy="authHeader">{{ title }}</div>
    <div class="auth-header__subtitle">
      {{ subtitle }}
      <span
        v-if="subtitleLink"
        class="link"
        data-cy="authLink"
        @click="$emit('changeAuthMode')"
        >{{ subtitleLink }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'log in',
    },
    subtitle: {
      type: String,
      default: 'log in',
    },
    subtitleLink: {
      type: String,
      default: '',
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.auth-header {
  text-align: center;

  &__title {
    font-weight: 600;
    font-size: 3rem;
    text-transform: uppercase;
  }

  &__subtitle {
    margin: 1rem 0;
    font-size: 1.25rem;

    .link {
      cursor: pointer;
      color: #00a7e1;
      margin-left: 0.25rem;
    }
  }
}
</style>
